import { Space, Typography } from "antd";
import { FormattedMessage } from "react-intl";
import Header from "components/layout/Header";

import { UserForm } from "../../Users/UserForm";

import { useVenueUserEditForm } from "./hooks";

const VenueUserEdit: React.FC = () => {
  const form = useVenueUserEditForm();

  return (
    <>
      <Header>
        <Typography.Title>
          <FormattedMessage defaultMessage="Edit User" />
        </Typography.Title>
      </Header>
      <Space />
      <UserForm {...form} />
    </>
  );
};

export default VenueUserEdit;
